import React from 'react';
import Parse from 'parse';
import {Glyphicon, Label} from 'react-bootstrap';

export default class OpenActions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            count: 0,
            countOwn: 0,
        }
    }

    componentDidMount() {
        let _this = this;
        let Project = Parse.Object.extend("Project");
        let project = new Project();
        project.id = this.props.project.id;
        new Parse.Query("Action")
            .equalTo("project", project)
            .notEqualTo("status", "completed")
            .notEqualTo("deleted", true)
            .count().then(count => {
                _this.setState({
                    count: count
                })
        });
        new Parse.Query("Action")
            .equalTo("project", project)
            .equalTo("user", Parse.User.current())
            .notEqualTo("status", "completed")
            .notEqualTo("deleted", true)
            .count().then(count => {
            _this.setState({
                countOwn: count
            })
        });
    }

    render() {
        return (
            <div>
                {/*You: {this.state.countOwn} / All: {this.state.count}*/}
                <Label bsStyle={this.state.countOwn === 0 ? "default" : "info"}><Glyphicon glyph="user"/> {this.state.countOwn}</Label>
                <span style={{fontSize:'75%',fontWeight:'700',color:'#ccc'}}> / </span>
                <span style={{fontSize:'75%',fontWeight:'700'}}>{this.state.count}</span>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/open-actions.js